import type { ParsedErrorMap } from './types';

type BENestedErrors = {
  [key: string]: string[] | BENestedErrors;
};

const isPlainObject = (value: unknown): value is BENestedErrors =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const segmentFor = (key: string, parentKey: string | null): string => {
  if (/^\d+$/.test(key) && parentKey !== null) {
    return `[${key}]`;
  }

  return key;
};

const parseErrors = (errors: BENestedErrors | null | undefined): ParsedErrorMap => {
  const result: ParsedErrorMap = {};

  const visit = (node: BENestedErrors, path: string, lastKey: string | null) => {
    Object.entries(node).forEach(([key, value]) => {
      const segment = segmentFor(key, lastKey);
      const nextPath = path === '' ? segment : `${path}${segment.startsWith('[') ? '' : '.'}${segment}`;

      if (Array.isArray(value)) {
        result[nextPath] = value.filter((m): m is string => typeof m === 'string');

        return;
      }

      if (isPlainObject(value)) {
        visit(value, nextPath, key);
      }
    });
  };

  if (isPlainObject(errors)) {
    visit(errors, '', null);
  }

  return result;
};

export default parseErrors;
